import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class ClassInfo
{
  static readonly type = new ElementType( "class-info" );
  static readonly className = new ElementType( "class-name" );
  
  static readonly isCSOnly = new ElementAttribute( "is-cs" );
  static readonly sourcePath = new ElementAttribute( "source-path" );
  static readonly definitionType = new ElementAttribute( "definition-type" );

  
  static readonly classNamespace = new ElementType( "class-namespace" );
  static readonly classInheritance = new ElementType( "class-inheritance" );
  static readonly classInterfaces = new ElementType( "class-interfaces" );
  static readonly classInheritanceArrow = new ElementType( "class-inheritance-arrow" );
  static readonly sourcePathElement = new ElementType( "source-path-element");
  static readonly classTitle = new ElementType( "class-title" );
  static readonly classIcon = new ElementType( "class-icon" );
  static readonly classDescription= new ElementType( "class-description" );
  static readonly classDescriptionSplitView= new ElementType( "class-description-split-view" );
  static readonly classDescriptionInfo = new ElementType( "class-description-info" );
  static readonly classDescriptionInspector = new ElementType( "class-description-inspector" );
  
}
